import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Button } from '@/components/foundation/Button';
import { isChunkLoadError, reloadOnceForStaleChunk } from '@/lib/lazy-retry';

export default function RouterErrorPage() {
  const error = useRouteError();
  let message = 'An unexpected error occurred.';
  let chunkStale = false;

  if (isRouteErrorResponse(error)) {
    message = error.statusText || message;
  } else if (error instanceof Error) {
    message = error.message;
    chunkStale = isChunkLoadError(error);
  } else if (typeof error === 'string') {
    message = error;
    chunkStale = isChunkLoadError(error);
  }

  useEffect(() => {
    if (chunkStale) reloadOnceForStaleChunk();
  }, [chunkStale]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[var(--bg-primary)] px-6 text-center">
      <h1 className="text-2xl font-semibold text-[var(--text-primary)]">
        {chunkStale ? 'App update available' : 'Unexpected application error'}
      </h1>
      <p className="max-w-lg text-sm text-[var(--text-muted)]">
        {chunkStale
          ? 'The app was updated while this tab was open. Reload once to load the latest version.'
          : message}
      </p>
      {!chunkStale ? (
        <p className="max-w-lg break-all text-xs text-[var(--text-muted)]">{message}</p>
      ) : null}
      <Button onClick={() => window.location.reload()}>Reload page</Button>
    </div>
  );
}
